import { yieldToMain } from '../../components/helpers';

document.arrive('a[data-remote=true], a[data-turbo-method], a[data-turbo=true], .remote_modal_link', async function(element) {
  // Yield to the main thread:
  await yieldToMain();
  element.onclick = function(e) {
    if (e && (e.ctrlKey || e.which === 2 || e.button === 4)) {
      e.preventDefault();
      e.currentTarget.click();
      return false;
    }
  };
  element.onauxclick = function(e) {
    if (e && (e.ctrlKey || e.which === 2 || e.button === 4)) {
      e.preventDefault();
      e.currentTarget.click();
      return false;
    }
  };
  // En production uniquement : on neutralise le menu contextuel (clic droit /
  // appui long sur mobile) pour empêcher « Ouvrir dans un nouvel onglet » sur
  // ces liens pilotés en JS (remote / turbo / modale), qui déclencherait un GET
  // brut court-circuitant le handler AJAX/modale (cf. TOP-3331). En dev on le
  // laisse actif afin de pouvoir inspecter ces liens-boutons (clic droit →
  // « Inspecter »), bloqué autrement.
  //
  // TODO (fix racine — rendrait ce blocage inutile) : plutôt que de masquer le
  // menu, rendre ces liens ouvrables sans casse. Pour chaque lien, faire
  // pointer le href vers une vraie page accessible en GET (amélioration
  // progressive / philosophie Hotwire) : le clic normal continue d'ouvrir la
  // modale / l'AJAX, et un « ouvrir dans un nouvel onglet » retombe alors sur
  // une page valide. Cas typiques : .remote_modal_link → page « show » de la
  // ressource ; liens data-turbo-method (DELETE/PATCH) → page de confirmation
  // GET-able. Une fois tous les href corrigés, supprimer ce bloc oncontextmenu.
  if (process.env.NODE_ENV === 'production') {
    element.oncontextmenu = function(e) {
      if (e) {
        e.preventDefault();
        return false;
      }
    };
  }
});
